export const formatCalendarAppointmentDisplayName = appt => {
  return appt.doctor
    ? `${appt.doctor.Fname ? appt.doctor.Fname : ''}${
        appt.doctor.Lname ? ` ${appt.doctor.Lname}` : ''
      } at ${appt.time_of_appointment}`
    : appt.lab_test
    ? appt.lab_test.title
    : ''
}
